import { z } from 'zod';

export const VuexAuthSchema = z.object({
  auth: z.object({
    accessToken: z.string(),
    idToken: z.string(),
  }),
});

export type VuexAuth = z.infer<typeof VuexAuthSchema>;

export const IdTokenSchema = z.object({
  sub: z.string(),
  address: z
    .object({
      formatted: z.string(),
    })
    .optional(),
  // TT-137: optional so admin-created accounts (e.g. Wakala investors), which
  // are minimal at creation and lack these claims, can still hydrate auth and
  // reach the profile-completion flow. Every self-signup carries both, so their
  // tokens parse identically — this only stops REJECTING minimal accounts.
  birthdate: z.string().optional(),
  iss: z.string(),
  'cognito:username': z.string().optional(),
  'custom:city': z.string().optional(),
  'custom:postcode': z.string().optional(),
  aud: z.string(),
  event_id: z.string(),
  token_use: z.string(),
  auth_time: z.number(),
  name: z.string(),
  phone_number: z.string().optional(),
  exp: z.number(),
  iat: z.number(),
  email: z.string().email(),
});

export type IdToken = z.infer<typeof IdTokenSchema>;
